export default __webpack_public_path__ + "static/media/7minfitness_3@2x.16da0323.jpg";